












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxLookup, DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { MailConfig } from '@/installationConfig';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

import {
  ContactsClient,
  MailTemplateType,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  IMailOrderCommand,
  IMailTemplateDto,
  MailOrderCommand,
  MailTemplatesClient,
  OrdersClient,
  MailContractCommand,
  ILocation
} from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxLookup,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class OrderMailPopup extends Vue {
  show: boolean = false;
  sending: boolean = false;
  formdata: IMailOrderCommand | any = {
    template: '',
    to: [],
    cc: [],
    subject: '',
    content: '',
    objectId: '',
    from: '',
  };
  templates: IMailTemplateDto[] = [];

  @Prop({ required: true })
  order!: IOrder;

  @Prop()
  projectNumber!: string;

  @Prop()
  projectLocation!: ILocation;

  public async open() {
    this.formdata.objectId = this.order.id;

    const lastUsedEmail = localStorage.getItem('order_last_used_email');
    const lastUsedTemplate = localStorage.getItem('order_last_used_template');
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (lastUsedTemplate) {
      this.formdata.template = lastUsedTemplate;
      const template = this.templates.find((o) => o.name === lastUsedTemplate);
      if (template) {
        this.formdata.subject = template.subject ? this.replaceTags(template.subject) : '';
        this.formdata.content = template.content ? this.replaceTags(template.content) : '';
      }
    }

    try {
      const contact = await new ContactsClient(undefined, this.$axios).getBasicInfo(this.order.supplierId);
      if (contact && contact.email) {
        this.formdata.to!.push(contact.email);
      }
    } catch (err) {
      // do nothing
    }

    this.show = true;
  }

  async created() {
    try {
      this.templates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.Order);
    } catch {
      // do nothing
    }
  }

  async send() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.sending = true;

      if (this.formdata.from) {
        localStorage.setItem('order_last_used_email', this.formdata.from);
        localStorage.setItem('order_last_used_template', this.formdata.template);
      }

      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>');

      await new OrdersClient(undefined, this.$axios).mail(new MailOrderCommand(this.formdata));
      notificationService.showSuccessMessage('Mail verstuurd');
      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
    }
  }

  replaceTags(content: string) {
    let replacedContent = content;

    while (replacedContent.indexOf('#Name') !== -1) {
      replacedContent = replacedContent.replace('#Name', this.order.supplierName ?? '');
    }

    while ((replacedContent as string).indexOf('#DocumentNumber') !== -1) {
      replacedContent = replacedContent.replace('#DocumentNumber', this.order.documentNumber);
    }

    while (replacedContent.indexOf('#Contact_Firstname') !== -1) {
      replacedContent = replacedContent.replace('#Contact_Firstname', '');
    }

    while (replacedContent.indexOf('#Contact_Lastname') !== -1) {
      replacedContent = replacedContent.replace('#Contact_Lastname', '');
    }

    while (replacedContent.indexOf('#Project_Name') !== -1) {
      replacedContent = replacedContent.replace('#Project_Name', this.order.projectName);
    }

    while (replacedContent.indexOf('#Project_DocumentNumber') !== -1) {
      replacedContent = replacedContent.replace('#Project_DocumentNumber', this.projectNumber);
    }

    while (replacedContent.indexOf('#Date') !== -1) {
      const date = this.order.date instanceof Date ? (this.order.date as Date).toLocaleDateString() : this.order.date.toString();
      replacedContent = replacedContent.replace('#Date', date);
    }

    if (this.projectLocation) {
      while (replacedContent.indexOf('#Project_Location') !== -1) {
        replacedContent = replacedContent.replace('#Project_Location', `https://www.google.com/maps/search/?api=1&query=${this.projectLocation.latitude},${this.projectLocation.longitude})`);
      }
    }

    while (replacedContent.indexOf('#OrderNumber') !== -1) {
      replacedContent = replacedContent.replace('#OrderNumber', this.order.documentNumber);
    }

    return replacedContent;
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }
          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              projectId: undefined,
              options: new DataSourceLoadOptionsBase(
                Object.assign({}, loadOptions, {
                  stringToLower: true,
                })
              ),
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: true,
    });
  }

  get contactOptions() {
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.subject = self.replaceTags(e.itemData.subject);
        self.formdata.content = self.replaceTags(e.itemData.content);
        self.formdata.language = e.itemData.language;
      },
    };
  }
}
